(() => {
  if (!window.__bbwNightPromoCloseGuard) {
    window.__bbwNightPromoCloseGuard = true;

    document.addEventListener('click', (event) => {
      const overlay = event.target?.closest?.('[data-bbw-night-overlay]');
      if (!overlay || event.target !== overlay) return;
      const promo = overlay.closest('[data-bbw-night-promo]');
      if (!promo?.classList.contains('is-open')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!document.querySelector('[data-bbw-night-promo].is-open')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  const root = document.querySelector('[data-bbw-assistant]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const launcher = root.querySelector('[data-bbw-assistant-launcher]');
  const panel = root.querySelector('[data-bbw-assistant-panel]');
  const closeButton = root.querySelector('[data-bbw-assistant-close]');
  const form = root.querySelector('[data-bbw-assistant-form]');
  const input = root.querySelector('[data-bbw-assistant-input]');
  const submit = root.querySelector('[data-bbw-assistant-submit]');
  const messages = root.querySelector('[data-bbw-assistant-messages]');
  const prompts = root.querySelector('[data-bbw-assistant-prompts]');
  const endpoint = root.dataset.endpoint;
  const history = [];
  let busy = false;

  const setOpen = (open) => {
    root.classList.toggle('is-open', open);
    launcher.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    if (open) window.setTimeout(() => input.focus(), 40);
    else launcher.focus();
  };

  const setBusy = (value) => {
    busy = value;
    submit.disabled = value;
    input.disabled = value;
    prompts?.querySelectorAll('button').forEach((button) => { button.disabled = value; });
  };

  const appendMessage = (text, role, links = []) => {
    const wrapper = document.createElement('div');
    wrapper.className = `bbw-assistant__message bbw-assistant__message--${role}`;
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    wrapper.append(paragraph);

    if (links.length) {
      const linkList = document.createElement('div');
      linkList.className = 'bbw-assistant__links';
      links.forEach((item) => {
        const link = document.createElement('a');
        link.href = item.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = item.title;
        linkList.append(link);
      });
      wrapper.append(linkList);
    }

    messages.append(wrapper);
    messages.scrollTop = messages.scrollHeight;
    return wrapper;
  };

  const ask = async (question) => {
    const message = String(question || '').replace(/\s+/g, ' ').trim();
    if (busy || message.length < 3) return;
    prompts?.remove();
    appendMessage(message, 'user');
    input.value = '';
    const loading = appendMessage('Looking through BeBetter resources…', 'loading');
    setBusy(true);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, history: history.slice(-4) }),
      });
      const body = await response.json().catch(() => ({}));
      loading.remove();
      if (!response.ok) throw new Error(body.error || 'The BeBetter Guide is temporarily unavailable.');
      appendMessage(body.answer, 'assistant', Array.isArray(body.links) ? body.links : []);
      history.push({ role: 'user', content: message }, { role: 'assistant', content: body.answer });
      if (history.length > 8) history.splice(0, history.length - 8);
    } catch (error) {
      loading.remove();
      appendMessage(error.message || 'The BeBetter Guide is temporarily unavailable.', 'error');
    } finally {
      setBusy(false);
      input.focus();
    }
  };

  launcher.addEventListener('click', () => setOpen(true));
  closeButton.addEventListener('click', () => setOpen(false));
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    ask(input.value);
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });
  prompts?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-prompt]');
    if (button) ask(button.dataset.prompt);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
  });
})();
